<template>
    <div class="env-subnet">
        <rcTable ref="rcTable"
                 v-if="securityId"
                 :tableAttr="tableAttr">
            <Button slot="tootipL"
                    @click="refreshTable">
                <i class="icon-refresh-o-2"></i>
            </Button>
            <Button type="primary"
                    @click="addRulesFun"
                    v-if="hasPermission('CB090406')"
                    slot="tootipL">
                <i class="icon-plus-o-1"></i><span>{{$t('创建规则')}}</span>
            </Button>
        </rcTable>
        <Modal v-model="modalEdit"
               :title="$t('修改描述')"
               class="securitygroup-form"
               :mask-closable="false"
               @on-cancel="handleReset">
            <Form ref="formSlblist"
                  :model="formData"
                  class="slbist-addform"
                  :label-width="100">
                <FormItem :label="`${$t('描述')}:`">
                    <Input v-model="formData.description"
                           type="textarea"
                           :maxlength="envType === 'Qcloud' ? 100 : 255"
                           :autosize=" { minRows: 6, maxRows: 10 }"
                           style="width:300px" />
                </FormItem>
            </Form>
            <div class="submit"
                 slot="footer">
                <Button @click="handleReset"
                        type="text"
                        style="margin-left: 8px">{{$t('取消')}}</Button>
                <Button type="primary"
                        @click="handleSubmit">{{$t('保存')}}</Button>

            </div>
        </Modal>
        <createrule ref="createrule"
                    :ruletype="ruletype"
                    :vpc="vpc"
                    @refreshTable="refreshTable"
                    :direction="direction"></createrule>
        <aliyuncreaterule ref="aliyuncreaterule"
                          :ruletype="ruletype"
                          :vpc="vpc"
                          :envType="envType"
                          @refreshTable="refreshTable"
                          :direction="direction"></aliyuncreaterule>
    </div>
</template>

<script>
import rcTable from '@c/basic/rcTable'
import createrule from './createrule.vue'
import aliyuncreaterule from './aliyuncreaterule.vue'
import API from '@/service/api.js'
import eventBus from '@/service/eventbus.js'
export default {
    name: 'subnet',
    props: ['type', 'vpc'],
    components: {
        rcTable,
        createrule,
        aliyuncreaterule
    },
    data () {
        return {
            // 是否显示table，依据是否给url&params赋值
            // showTable: false,
            noChange: true,
            modalEdit: false,
            formData: {
                description: ''
            },
            // 需要克隆的数据
            cloneData: {},
            securityId: '',
            ruletype: '',
            direction: '',
            tableAttr: {
                source: {
                    type: 'get',
                    url: '',
                    params: {
                        index: this.type === 'ingress' ? 1 : 2,
                        description: ''
                    }
                },
                searchColumns: [
                    {
                        key: 'description',
                        title: this.$t('描述'),
                        searchDefaultValue: ''
                    }
                ],
                searchShow: true,
                tableSearchKey: '', // 当作查询保持的key存在
                searchDefaultValueList: [], // 默认初始化搜索标签加入
                tableColKey: '',
                isMultiSelect: false,
                columnsChooseShow: true,
                columns: []
            },
            editData: {},
            envType: this.$route.query.envType,
            columns: [
                {
                    title: this.$t('授权策略'),
                    key: 'strategy',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    supportEnvs: ['Aliyun', 'Qcloud'],
                    render: (h, params) => {
                        return h('div', [
                            h('span', { style: (params.row.strategy !== 'ACTIVE' && this.$route.query.envType !== 'Aliyun' && this.$route.query.envType !== 'Qcloud' ? 'color:#1ebd62' : 'display:none') }, this.$t('允许')),
                            h('span', { style: (params.row.strategy === 'ACTIVE' && this.$route.query.envType !== 'Aliyun' && this.$route.query.envType !== 'Qcloud' ? 'color:#19be6b' : 'display:none') }, this.$t('禁止')),
                            h('span', { style: (params.row.strategy.toUpperCase() !== 'ACCEPT' && (this.$route.query.envType === 'Aliyun' || this.$route.query.envType === 'Qcloud') ? 'color:#1ebd62' : 'display:none') }, this.$t('拒绝')),
                            h('span', { style: (params.row.strategy.toUpperCase() === 'ACCEPT' && (this.$route.query.envType === 'Aliyun' || this.$route.query.envType === 'Qcloud') ? 'color:#19be6b' : 'display:none') }, this.$t('允许'))
                        ])
                    }
                },
                {
                    title: this.$t('以太网类型'),
                    key: 'ethertype',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    supportEnvs: ['OpenStack', 'OpenStack-Admin', 'Nine9Cloud', 'Nine9Cloud-Admin', 'ESCloud', 'ESCloud-Admin', 'CloudOS'],
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.ethertype } }, params.row.ethertype)
                    }
                },
                {
                    title: this.$t('端口范围'),
                    key: 'portRangeMin',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.cidr } }, params.row.portRangeMin === '-1' || params.row.portRangeMin === '' || params.row.portRangeMin === null ? '任何' : params.row.portRangeMin + ' - ' + params.row.portRangeMax)
                    }
                },
                {
                    title: this.$t('协议类型'),
                    key: 'protocol',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.protocol } }, params.row.protocol === null ? '任何' : params.row.protocol)
                    }
                },
                {
                    title: this.$t('授权类型'),
                    key: 'authObj',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true
                },
                {
                    title: this.$t('授权对象'),
                    key: 'remoteIpPrefix',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        let d = ''
                        if (params.row.authObj === '地址段访问') {
                            if (params.row.remoteIpPrefix.includes('/null')) {
                                const removeNull = params.row.remoteIpPrefix.substring(0, params.row.remoteIpPrefix.length - 5)
                                d = removeNull
                            } else {
                                d = params.row.remoteIpPrefix
                            }
                        } else if (params.row.authObj === '安全组访问') {
                            d = params.row.remoteGroupName
                        } else if (!this.isNullOrUndefined(params.row.range)) {
                            d = params.row.range
                        }
                        return h('p', { attrs: { title: d }, class: 'rc-ellipsis' }, d)
                    }
                },
                {
                    title: '优先级',
                    key: 'priority',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true
                },
                {
                    title: this.$t('描述'),
                    key: 'description',
                    className: 'ellipsis',
                    columnShow: true,
                    disabledSearch: true,
                    columnsChoosed: true,
                    render: (h, params) => {
                        return h('span', { attrs: { title: params.row.description } }, params.row.description)
                    }
                },
                {
                    title: this.$t('操作'),
                    width: 190,
                    render: (h, params) => {
                        return h('div', {
                            class: 'tbl-btn-div'
                        }, [
                            h('a', { class: { 'disabled-per': !this.hasPermission('CB090414') }, on: { click: () => this.hasPermission('CB090414') && this.editFun(params.row) } }, this.$t('修改描述')),
                            h('a', { class: { 'disabled-per': !this.hasPermission('CB090409') }, on: { click: () => this.hasPermission('CB090409') && this.cloneFun(params.row) } }, this.$t('克隆')),
                            h('a', { class: { 'disabled-per': !this.hasPermission('CB090408') }, on: { click: () => this.hasPermission('CB090408') && this.deleteFun(params.row) } }, this.$t('删除'))
                        ])
                    }
                }
            ]
        }
    },
    mounted () {
        const that = this
        eventBus.$on('setSecurityId', function (data) {
            that.tableAttr.source.url = this.urlFormat(API.GET_SECURITY_ENANDEX, false, [data.securityId])
            that.securityId = data.securityId
        })
        this.handleDifEnv()
    },
    methods: {
        // 不同云环境下显示的表格列名不同
        handleDifEnv () {
            this.tableAttr.columns = [...this.columns].filter(col => {
                let res = false
                if (!col.excludeEnvs && !col.supportEnvs) {
                    res = true
                } else if (col.supportEnvs && col.supportEnvs.includes(this.envType)) {
                    res = true
                } else if (col.excludeEnvs && !col.excludeEnvs.includes(this.envType)) {
                    res = true
                }
                return res
            })
        },
        refreshTable () {
            this.$refs.rcTable && this.$refs.rcTable.refreshTable()
        },
        // 添加规则
        addRulesFun () {
            if (!this.hasPermission('CB090406')) return
            this.$nextTick(() => {
                this.ruletype = 'add'
                this.direction = this.type
                if (this.$route.query.envType === 'Aliyun' || this.$route.query.envType === 'Qcloud') {
                    this.$refs.aliyuncreaterule.openModal()
                } else {
                    this.$refs.createrule.openModal()
                }
            })
        },
        // 克隆规则
        cloneFun (params) {
            if (!this.hasPermission('CB090409')) return
            this.$nextTick(() => {
                this.ruletype = 'clone'
                this.direction = this.type
                if (this.$route.query.envType === 'Aliyun' || this.$route.query.envType === 'Qcloud') {
                    this.$refs.aliyuncreaterule.openModal(params)
                } else {
                    this.$refs.createrule.openModal(params)
                }
            })
        },
        deleteFun (id) {
            if (!this.hasPermission('CB090408')) return
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('确认要删除该规则?'),
                onOk: () => {
                    let obj = {}
                    if (this.$route.query.envType === 'Aliyun' || this.$route.query.envType === 'Qcloud') {
                        obj = {
                            portRangeMax: id.portRangeMax,
                            portRangeMin: id.portRangeMin,
                            protocol: id.protocol,
                            id: this.securityId,
                            remoteIpPrefix: id.remoteIpPrefix,
                            remoteGroupId: id.remoteGroupId,
                            direction: id.direction
                        }
                    } else {
                        obj = {
                            ruleId: id.id,
                            id: this.securityId
                        }
                    }
                    if (this.$route.query.envType === 'Qcloud') {
                        obj.authorizationStrategy = id.strategy
                    }
                    this.axios.delete(this.urlFormat(API.CREATED_RULE, false), {
                        data: obj
                    }).then(res => {
                        this.refreshTable()
                    })
                }
            })
        },
        editFun (obj) {
            if (!this.hasPermission('CB090403')) return
            this.modalEdit = true
            this.ruleId = obj.id
            this.editData = obj
            this.formData.description = obj.description
        },
        // 修改描述
        handleSubmit () {
            const p = {
                securityGroupId: this.editData.securityGroupId,
                id: this.editData.id,
                direction: this.editData.direction,
                description: this.formData.description,
                remoteGroupId: this.editData.remoteGroupId,
                protocol: this.editData.protocol,
                portRangeMax: this.editData.portRangeMax,
                portRangeMin: this.editData.portRangeMin,
                remoteIpPrefix: this.editData.remoteIpPrefix
            }
            if (this.$route.query.envType === 'Aliyun' || this.$route.query.envType === 'Qcloud') {
                p.priority = this.editData.priority
                p.strategy = this.editData.strategy
            }
            this.axios.put(this.urlFormat(API.CREATED_RULE, false), p).then(res => {
                this.refreshTable()
            })
            this.modalEdit = false
        },
        handleReset () {
            this.modalEdit = false
        },
        isNullOrUndefined (val) {
            if (val === null || val === undefined) {
                return true
            }
        }
    }
}
</script>
